import { connect } from "react-redux";
import InfoDate from "./InfoDate";

export default connect(state => ({
	date: state.rtc,
	tz: state.ablauf.system.tz
}))(InfoDate);
